import { useTranslation } from "@localization/useTranslation";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { getRiskLevelColor } from "../../riskLevelColor";
import { getRiskLevelIcon } from "../../riskLevelIcon";
import { mitigationStatusTranslationKey, RiskMitigationPlanStatus } from "../../riskMitigationStatus";
import { eventKindTranslationKey, RiskHistoryEventKind } from "../RiskHistoryOverview.types";
import { RiskAssessmentTimeline } from "./RiskAssessmentTimelineDialog.types";
import { AssessmentConfidence, assessmentConfidenceTranslationKey } from "../../AssessmentConfidence";

export function useRiskAssessmentTimelineDialog(riskAssessmentId: string) {
    const { translateString } = useTranslation();

    const historyUrl = `/risk-assessments/${riskAssessmentId}/history`;
    const { data, isLoading } = useDotLegalQuery<RiskAssessmentTimeline>(historyUrl);

    const getEventLabel = (kind: RiskHistoryEventKind) => translateString(eventKindTranslationKey[kind]);
    const getPlanStatusLabel = (status: RiskMitigationPlanStatus) => translateString(mitigationStatusTranslationKey[status]);
    const getConfidenceLabel = (confidence: AssessmentConfidence) => translateString(assessmentConfidenceTranslationKey[confidence]);
    const getRiskColor = (level: number, scale: number) => getRiskLevelColor(level, scale);
    const getRiskIcon = (level: number, scale: number) => getRiskLevelIcon(level, scale);

    return {
        timeline: data,
        isLoading,
        getEventLabel,
        getPlanStatusLabel,
        getConfidenceLabel,
        getRiskColor,
        getRiskIcon,
    };
}
